import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../services/api';
import { toast } from 'sonner';
import { ArrowLeft } from 'lucide-react';

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await authService.forgotPassword(email);
      setSent(true);
      toast.success('Email envoyé');
    } catch (error) {
      toast.error('Erreur lors de l\'envoi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-white/5">
      <div className="w-full max-w-md bg-[#0B132B] border border-white/10 rounded-lg p-8">
        <Link to="/login" className="flex items-center gap-2 text-sm text-slate-400 hover:text-white mb-6" data-testid="back-to-login">
          <ArrowLeft size={16} />
          Retour à la connexion
        </Link>

        <h2 className="text-2xl font-semibold text-white mb-2">Mot de passe oublié</h2>
        <p className="text-sm text-slate-400 mb-6">
          Entrez votre email pour recevoir un nouveau mot de passe provisoire
        </p>

        {!sent ? (
          <form onSubmit={handleSubmit} data-testid="forgot-password-form">
            <div className="mb-6">
              <label className="eva-label">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="eva-input"
                required
                data-testid="email-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="eva-btn-primary w-full"
              data-testid="submit-button"
            >
              {loading ? 'Envoi...' : 'Réinitialiser mon mot de passe'}
            </button>
          </form>
        ) : (
          <div className="text-center">
            <div className="w-16 h-16 bg-emerald-500/15 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-[#10B981]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-base text-slate-300">
              Si cet email existe, un nouveau mot de passe provisoire a été envoyé.<br />
              <span className="text-sm text-slate-400 mt-2 block">Pensez à vérifier vos spams.</span>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};